import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import logo from "../assets/logo_s.png";
import mapblue from "../assets/mgl.png";
import maphil from "../assets/neg.png";
import hoyr from "../assets/2.png";
import guraw from "../assets/3.png";
import duruv from "../assets/4.png";
import tav from "../assets/5.png";
import zurgaa from "../assets/6.png";
import naim from "../assets/8.png";
import ys from "../assets/9-removebg-preview.png";
import mongolbichig from "../assets/mb.png";
import Hil from "./Modal/Hil";
import Boomt from "./Modal/Boomt";
import Gadaad from "./Modal/Gadaad";
import Ulsinhil from "./Modal/Ulsinhil";
import Arhiv1 from "./Modal/Arhiv1";
import Arhiv2 from "./Modal/Arhiv2";
import Arhiv3 from "./Modal/Arhiv3";
import Arhiv4 from "./Modal/Arhiv4";

// Desktop: original 16-column layout. Tablet: 2 or 3 cards per row.
// Mobile: 1 card per row; larger phones: 2 cards per row.
const cardStyle = {
  width: "100%",
  height: { xs: "100%", lg: "100%" },
  minHeight: { xs: 150, sm: 170, lg: 0 },
  boxSizing: "border-box",
  borderRadius: "22px",
  background: "rgba(255,255,255,0.08)",
  backgroundImage:
    "linear-gradient(135deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.05) 100%)",
  border: "1px solid rgba(255,255,255,0.18)",
  backdropFilter: "blur(18px) saturate(180%)",
  WebkitBackdropFilter: "blur(18px) saturate(180%)",
  boxShadow: "0 8px 32px rgba(0,0,0,0.37)",
  position: "relative",
  overflow: "hidden",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  color: "#fff",
  p: 1.5,
  transition: "all 0.35s ease",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "22px",
    padding: "2px",
    background: "linear-gradient(90deg, #6bbcff, #ffffff, #6bbcff)",
    opacity: 0,
    transition: "opacity 0.4s ease",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
  },
  "&:hover::before": { opacity: 1 },
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0 18px 50px rgba(0,0,0,0.55)",
  },
  "&:focus-visible": { outline: "3px solid #fff", outlineOffset: 3 },
};

// Use CSS columns/rows so desktop positioning stays as before.
const serviceGrid = {
  gridColumn: { xs: "span 1", sm: "span 1", md: "span 1", lg: "span 2" },
  gridRow: { xs: "auto", lg: "span 1" },
};

const services = [
  { id: "one", title: "Хилийн бүс нутагт нэвтрэх зөвшөөрөл", icon: maphil },
  {
    id: "eight",
    title: "Хугацаат цэргийн алба хаасан тухай лавлагаа",
    icon: naim,
  },
  { id: "two", title: "Хилийн боомтод нэвтрэх зөвшөөрөл", icon: hoyr },
  { id: "three", title: "Гадаад улсад зорчих эрхийн лавлагаа", icon: tav },
  { id: "four", title: "Улсын хилээр нэвтэрсэн иргэний лавлагаа", icon: ys },
  { id: "five", title: "Ажилласан жилийн лавлагаа", icon: duruv },
  { id: "six", title: "Цалингийн лавлагаа", icon: guraw },
  {
    id: "seven",
    title: "Тушаал шийдвэр, бусад баримтын хуулбар авах",
    icon: zurgaa,
  },
];

const MainActivity = ({
  cyberdata,
  plandata,
  zaswardata,
  programmdata,
  mtdata,
  holboodata,
}) => {
  const [opened, setOpened] = useState(null);
  useEffect(() => {
    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });

      let parent = document.getElementById("main-activity")?.parentElement;

      while (parent) {
        if (parent.scrollHeight > parent.clientHeight) {
          parent.scrollTop = 0;
        }
        parent = parent.parentElement;
      }
    };

    resetScroll();
  }, []);
  const card = (id) => {
    const item = services.find((service) => service.id === id);
    return (
      <Box key={id} sx={serviceGrid}>
        <Box
          role="button"
          tabIndex={0}
          aria-label={item.title}
          onClick={() => setOpened(id)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setOpened(id);
            }
          }}
          sx={cardStyle}
        >
          <Box
            component="img"
            src={item.icon}
            alt=""
            sx={{
              width: id === "eight" ? 34 : 30,
              mb: 1,
              ...(id === "four" ? { backgroundColor: "#fff" } : {}),
            }}
          />
          <Typography
            sx={{
              fontWeight: 300,
              fontSize: { xs: 14, lg: 14 },
              lineHeight: "20px",
            }}
          >
            {item.title}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box
      id="main-activity"
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        height: "auto",
        minHeight: { xs: "100dvh", lg: "auto" },
        display: "block",
        position: "relative",
        overflow: "visible",
        margin: 0,
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(3, minmax(0, 1fr))",
            lg: "repeat(16, minmax(0, 1fr))", // desktop original
          },
          gridAutoRows: { xs: "auto", lg: "200px" },
          gap: { xs: "12px", sm: "16px", lg: "20px" },
          m: { xs: 0, lg: 5 },
          p: { xs: 2, sm: 2.5, lg: 2 },
          opacity: 0.9,
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        {/* Vertical Mongolian script - preserve on desktop */}
        <Box
          sx={{
            display: { xs: "none", lg: "block" },
            gridColumn: "span 2",
            gridRow: "span 4",
          }}
        >
          <Box
            component="img"
            src={mongolbichig}
            alt="Монгол бичиг"
            sx={{ width: "70%" }}
          />
        </Box>

        {/* Logo */}
        <Box
          sx={{
            gridColumn: { xs: "1 / -1", lg: "span 5" },
            gridRow: { lg: "span 1" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              justifyContent: { xs: "center", lg: "flex-start" },
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="ХХЕГ сүлд"
              sx={{
                width: { xs: 72, sm: 85, lg: 100 },
                mr: { lg: 2 },
                flexShrink: 0,
              }}
            />
            <Box sx={{ mr: { lg: 2 } }}>
              <Typography
                sx={{
                  color: "#fff",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: { xs: 10, lg: 12 },
                  mt: { lg: "clamp(8px, 2vw, 32px)" },
                  lineHeight: 1.15,
                }}
              >
                ЗАСГИЙН ГАЗРЫН
                <br />
                ХЭРЭГЖҮҮЛЭГЧ АГЕНТЛАГ
              </Typography>
              <Typography
                sx={{
                  color: "#fff",
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: { xs: 16, lg: 20 },
                  lineHeight: 1.15,
                }}
              >
                ХИЛ ХАМГААЛАХ
                <br />
                ЕРӨНХИЙ ГАЗАР
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Headline */}

        <Box
          sx={{
            gridColumn: { xs: "1 / -1", lg: "span 9" },
            gridRow: { xs: "auto", lg: "span 1" },

            color: "#fff",
            textAlign: "center",
            fontWeight: "bold",

            fontSize: {
              xs: "12px",
              sm: "15px",
              md: "18px",
              lg: "20px",
            },

            lineHeight: {
              xs: 1.6,
              sm: 1.5,
              lg: 1.2,
            },

            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",

            px: {
              xs: 2,
              sm: 2,
              lg: 0,
            },

            mt: { xs: 2, lg: 5 },
            mb: { xs: 2, lg: 0 },

            whiteSpace: "normal",
            overflowWrap: "break-word",

            textShadow: "0 0 6px #000000c4, 0 0 12px #000000c4",
          }}
        >
          ХИЛ ХАМГААЛАХ БАЙГУУЛЛАГААС ИРГЭН, АЖ АХУЙН НЭГЖИД
          <Box component="span" sx={{ display: { xs: "none", lg: "block" } }} />
          <Box component="span" sx={{ display: "block" }}>
            ОЛГОДОГ ҮЙЛЧИЛГЭЭГ И-МОНГОЛИА СИСТЕМЭЭР АВАХ ЗААВАР
          </Box>
        </Box>

        {/* Desktop spacing item */}
        <Box
          sx={{
            display: { xs: "none", lg: "block" },
            gridColumn: "span 2",
            gridRow: "span 1",
          }}
        />

        {/* Map */}
        <Box
          sx={{
            gridColumn: { xs: "1 / -1", lg: "span 8" },
            gridRow: { xs: "auto", lg: "span 2" },

            width: "100%",
            minWidth: 0,

            height: {
              xs: 230,
              sm: 320,
              md: 350,
              lg: "auto",
            },

            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "visible",
            // position: "relative", display: "flex", justifyContent: "center", alignItems: "center",
            // minWidth: 0,
            // height: { xs: 240, sm: 320, md: 350, lg: "auto" },
            // overflow: "visible",
            "&::after": {
              content: '""',
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              height: "90%",
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(0,150,255,0.6), transparent)",
              filter: "blur(70px)",
              zIndex: 0,
              animation: "pulseGlow 2.5s infinite ease-in-out",
            },
            "@keyframes pulseGlow": {
              "0%,100%": {
                opacity: 0.3,
                transform: "translate(-50%, -50%) scale(0.9)",
              },
              "50%": {
                opacity: 1,
                transform: "translate(-50%, -50%) scale(1.1)",
              },
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: { xs: "100%", lg: 500 },
              position: "relative",
              zIndex: 2,
              top: {
                xs: 0,
                lg: "-20%",
              },
            }}
          >
            <Box
              component="img"
              src={mapblue}
              alt="Монгол Улсын газрын зураг"
              sx={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "90%",
                color: "#040d94ff",
                fontSize: { xs: 12, sm: 16, md: 20, lg: 28 },
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: 1.2,
                pointerEvents: "none",
                animation: "glow-rotate 3s linear infinite",
                "@keyframes glow-rotate": {
                  "0%,100%": {
                    textShadow:
                      "0 0 4px #7eff5ec4, 0 0 8px #7eff5ec4, 0 0 16px rgba(255,255,255,.5)",
                  },
                  "50%": {
                    textShadow: "0 0 8px rgba(0,0,0,.3), 0 0 16px #fff",
                  },
                },
              }}
            >
              МОНГОЛ УЛСЫН ХИЛ ТАЙВАН БАЙНА
            </Box>
          </Box>
        </Box>

        {/* Desktop empty space before first card */}
        <Box
          sx={{
            display: { xs: "none", lg: "block" },
            gridColumn: "span 4",
            gridRow: "span 1",
          }}
        />
        {card("one")}
        {card("eight")}
        {/* Desktop empty space before the 6-card last row */}
        <Box
          sx={{
            display: { xs: "none", lg: "block" },
            gridColumn: "span 2",
            gridRow: "span 1",
          }}
        />
        {card("two")}
        {card("three")}
        {card("four")}
        {card("five")}
        {card("six")}
        {card("seven")}
        <Box
          sx={{
            display: { xs: "none", lg: "block" },
            gridColumn: "span 2",
            gridRow: "span 1",
          }}
        />
      </Box>

      <Hil one={opened === "one"} onClose={() => setOpened(null)} />
      <Boomt two={opened === "two"} onClose={() => setOpened(null)} />
      <Gadaad three={opened === "three"} onClose={() => setOpened(null)} />
      <Ulsinhil four={opened === "four"} onClose={() => setOpened(null)} />
      <Arhiv1 five={opened === "five"} onClose={() => setOpened(null)} />
      <Arhiv2 six={opened === "six"} onClose={() => setOpened(null)} />
      <Arhiv3 seven={opened === "seven"} onClose={() => setOpened(null)} />
      <Arhiv4 eight={opened === "eight"} onClose={() => setOpened(null)} />
    </Box>
  );
};

export default MainActivity;
